import {DATA_TYPES} from "@/utils/content-scripts/mark.decorator";
import {escapeRegExp} from "@/utils/functions";

/**
 * Negative Word Entity properties
 *  @param {Object} source - object with Negative Word Entity
 *   @param {Boolean} source.boundary - boundary
 *   @param {String} source.category - category
 *   @param {String} source.color - HEX color string "#9DCFFB"
 *   @param {Boolean} source.enabled - enabled
 *   @param {String} source.word - word
 *   @param {String} source.word_category - word_category
 *   @param {String} source.word_type - word_type
 *   @param {String} source._id - id
 *
 *   @return {Object};
 */

function NegativeWordEntityToMarkEntityAdapter(source) {
    return {
        getEntity() {
            return {
                element: source,
                dataType: DATA_TYPES.negativeWords,
                pattern: new RegExp(`${escapeRegExp(source.word.trim())}`, "gmi"),
            };
        },
        getClasses() {
            const fixedClass = "neotas-list bad-words";
            const categoryClass = `neo-category-${source.word_type}`;
            const colorClass = `neo-color-${source.color.replace("#", "").toLowerCase()}`;
            return `${fixedClass} ${categoryClass} ${colorClass}`;
        },
        getAttributes() {
            const attributes = [];
            const hoverLabel = this.getHoverLabelAttribute();
            attributes.push(hoverLabel);
            return attributes;
        },
        getHoverLabelAttribute() {
            const hoverLabel = [];
            hoverLabel.push(source.category);
            hoverLabel.push(source.language ? source.language : "English");

            if (source.word_category) {
                hoverLabel.push(source.word_category);
            }

            hoverLabel.push(source.word);

            const label = hoverLabel.join(" - ");
            return {key: "title", value: label};
        },
    };
}

export default NegativeWordEntityToMarkEntityAdapter;
